// Not generated from samples: written from Appboy::Communication::Segment::CreatedFromFilter.

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

// User::GenerationMethod tokens, as listed by CreatedFromFilter.allowed_values.
const generationMethod = z.enum([
  "sdk",
  "rest",
  "pti",
  "csv",
  "demo",
  "sms",
  "shopify",
  "whats_app",
  "provider_event",
  "provider_sync",
  "landing_page",
  "messaging_api_mau",
]);

// A single token for is / is not, a list for is any of / is none of, and nothing for
// is blank / is not blank ("" or, once allow_nil_blank_filters is on, null).
const createdFromValue = z.union([z.null(), z.literal(""), generationMethod, z.array(generationMethod)]);

export const createdFromFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("created_from_filter"),
  // Constants::Comparisons.boolean_and_multivalue_comparisons(false)
  comparison_key: z.enum(["1", "2", "25", "26", "11", "12"]),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on. Same as `value`: the
  // allowed values are a plain list, so Filter#get_raw_value passes the value through.
  raw_value: createdFromValue.optional(),
  value: createdFromValue,
  varies_by_app_group: z.literal(false),
});
